/** Wire shape of one entry of `GET …/transcript/turns` (§8.1). */
export type TranscriptTurnPayload = {
	readonly id: number;
	readonly position: number;
	readonly text: string;
	readonly originalText: string | null;
	readonly startSecond: number | null;
	readonly endSecond: number | null;
	readonly speaker: { readonly id: number } | null;
};

export type TranscriptTurnsFetchedPayload = {
	readonly totalRecords: number;
	readonly results: readonly TranscriptTurnPayload[];
};

export type TranscriptTurnsFetchedAction = {
	type: 'TRANSCRIPT_TURNS_FETCHED';
	payload: TranscriptTurnsFetchedPayload;
	interviewId: number;
	// The page this batch answers, carried alongside the payload rather than derived from it: it is
	// what tells a first load apart from a next page, and what `appendPage` needs to stay idempotent
	// (`UI/Store/Interviews/Views/TranscriptTurnsListView.ts`).
	page: number;
};

export default (
	payload: TranscriptTurnsFetchedPayload,
	interviewId: number,
	page: number,
): TranscriptTurnsFetchedAction => ({
	type: 'TRANSCRIPT_TURNS_FETCHED',
	payload,
	interviewId,
	page,
});
